import React, { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from './logo';
import { useAuth } from '../context/auth-context';
import { discordService } from '../services/discord-service';

function Nav() {
  const { user, isAuthenticated, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLLIElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  return (
    <nav className="main-nav">
      <div className="nav-container">
        <Logo />
        <ul className="nav-links">
          <li>
            <NavLink to="/policy">Privacy Policy</NavLink>
          </li>
          <li>
            <NavLink to="/tos">Terms of Service</NavLink>
          </li>
          
          <li>
            <a 
              href="https://github.com/DMcP89/harambot" 
              aria-label="GitHub" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.042-1.416-4.042-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
          </li>

          {isAuthenticated && user ? (
            <li className={`user-menu-container ${isDropdownOpen ? 'active' : ''}`} ref={dropdownRef}>
              <div className="user-menu-trigger" onClick={toggleDropdown}>
                <img 
                  src={discordService.getAvatarUrl(user.id, user.avatar)} 
                  alt={user.username}
                  style={{ width: '32px', height: '32px', borderRadius: '50%' }}
                />
                <span>{user.username}</span>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  style={{ transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
                >
                  <path d="m6 9 6 6 6-6"/>
                </svg>
              </div>
              <div className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                <NavLink 
                  to="/profile" 
                  className="dropdown-item"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Profile
                </NavLink>
                <div className="dropdown-divider"></div>
                <button 
                  onClick={() => {
                    logout();
                    setIsDropdownOpen(false);
                  }} 
                  className="dropdown-item"
                >
                  Logout
                </button>
              </div>
            </li>
          ) : (
            <li>
              <a 
                href={discordService.getOAuthUrl()}
                className="discord-login-btn"
                style={{ 
                  backgroundColor: '#5865F2', 
                  color: 'white', 
                  padding: '8px 16px', 
                  borderRadius: '4px', 
                  textDecoration: 'none',
                  gap: '8px'
                }}
              >
                Login with Discord
              </a>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Nav;

